import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Divider } from '@mui/material';
import BasicChips from 'components/Chip';
import { BasicIconButton, BrandIconSpinner, Virtuoso } from 'components';

import { EndStyle } from 'pages/home/Home.style';
import { ProfileJobAppliedStatus } from '../jobs/JobPosts.style';
import { getUserJobSubmittedList } from 'redux/features/PostJobSlice';

import { ReactComponent as SampleCompany } from 'assert/images/Jobs/sampleCompany.svg';
import { ReactComponent as NoDataFound } from 'assert/images/Common/noDataFound.svg';
import { ReactComponent as ViewList } from "assert/images/Jobs/viewList.svg";
import { useTranslation } from 'react-i18next';

const pageSize = 15;

export default function JobAppliedStatus() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [isHasMore, setIsHasMore] = useState(0);

  const showDetails = (id) => {
    navigate(`/jobs-detail/${id}`);
  };

  const handleFetchData = () => {
    setLoading(true);
    dispatch(getUserJobSubmittedList(page, pageSize))
      .then((res) => {
        const response = res?.data?.data;
        setPage(page + 1);
        setStatusList([...statusList, ...response.rows]);
        setIsHasMore(response?.hasMore);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <ProfileJobAppliedStatus>
      <BrandIconSpinner loading={loading && statusList?.length === 0} />
      {statusList.length > 0 ? (
        <Virtuoso
          data={statusList}
          useWindowScroll
          minHeight="76.9vh"
          components={{
            Footer: () => {
              return (
                !isHasMore && (
                  <EndStyle>
                    <span>* * *</span>
                  </EndStyle>
                )
              );
            },
          }}
          endReached={
            isHasMore ? handleFetchData : () => {}
          }
          itemContent={(index, list) => {
            const status = list?.status;
            return (
              <div key={index}>
                <div className="applied-status-container">
                  <div>
                    {list?.jobPost?.companyLogo ? (
                      <img
                        alt="company-logo"
                        className="applied-status-company-logo"
                        src={list?.jobPost?.companyLogo}
                      />
                    ) : (
                      <SampleCompany className="applied-status-company-logo" />
                    )}
                  </div>
                  <div>
                    <a
                      href={`/jobs-detail/${list?.jobPostId}`}
                      className="applied-status-title"
                    >
                      {list?.jobPost?.jobTitle}
                    </a>
                    <div>{list?.jobPost?.companyName}</div>
                    {list?.jobPost?.location?.map((item, index) => {
                      return (
                        <span key={index}>
                          {item?.city ? item?.city + ', ' + item.name : item.name}
                        </span>
                      );
                    })}
                    <div className="applied-status-date">
                      {t('profile.AppliedOn')} {moment(list?.appliedOn).format('DD-MM-YYYY')}
                    </div>
                  </div>
                  <BasicIconButton
                    className="view-applied"
                    icon={<ViewList />}
                    onClick={() => showDetails(list?.jobPostId)}
                    ariaLabel="view-applied-job"
                    size="small"
                  />
                </div>
                  <div className="applied-status-chip-container">
                    <div className="status-title">{t('profile.Status')}</div>
                    <BasicChips
                      variant={status === null ? 'outlined' : 'filled'}
                      label={
                        status === 0
                          ? t('profile.OnHold')
                          : status === 1
                          ? t('profile.Selected')
                          : status === 2
                          ? t('profile.NotSelected')
                          : t('profile.InProgress')
                      }
                      color={
                        status === 0
                          ? 'primary'
                          : status === 1
                          ? 'success'
                          : status === 2
                          ? 'error'
                          : 'primary'
                      }
                    />
                    <div className="list-emoji">
                      {status === 1 ? '🥳' : status === null ? '🕵️‍♀️' : ''}
                    </div>
                  </div>
                <Divider />
              </div>
            );
          }}
        />
      ) : (
        <div className="no-data-found">
          <NoDataFound />
          <div>{t('Job.NoDataFound')}</div>
        </div>
      )}
    </ProfileJobAppliedStatus>
  );
}
